import { render, staticRenderFns } from "./AllTrend.vue?vue&type=template&id=658312b5&scoped=true&"
import script from "./AllTrend.vue?vue&type=script&lang=js&"
export * from "./AllTrend.vue?vue&type=script&lang=js&"
import style0 from "./AllTrend.vue?vue&type=style&index=0&id=658312b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658312b5",
  null
  
)

export default component.exports